import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgDeliveryTruck = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M21 3H10a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM10 5h11v11H10V5Z" />
      <path d="M9 9H5.5a1 1 0 0 0-.678.265l-3.5 3.23a1 1 0 0 0-.322.736V17a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1Zm-1 2v5H3v-2.332L5.89 11H8Z" />
      <path d="M9 17a1 1 0 0 1 1 1 3 3 0 0 1-6 0 1 1 0 0 1 1.993-.117L6 18a1 1 0 0 0 1.993.117L8 18a1 1 0 0 1 1-1ZM20 17a1 1 0 0 1 1 1 3 3 0 0 1-6 0 1 1 0 0 1 1.993-.117L17 18a1 1 0 0 0 1.993.117L19 18a1 1 0 0 1 1-1Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgDeliveryTruck)
const Memo = memo(ForwardRef)
export default Memo
